import { cn } from "@base/lib/utils";
import { mdiChevronDown, mdiInformationOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const MeetingRoomNotice = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="overflow-hidden rounded-4 border border-gray-300 bg-gray-10 p-[10px]">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex gap-2 items-center w-full text-left"
        aria-expanded={isOpen}
      >
        <Icon path={mdiInformationOutline} size="1.25rem" className="text-gray-900 shrink-0" />
        <h3 className="flex-1 text-subtitle5 text-gray-1000">{t("reservationPolicyTitle")}</h3>
        <Icon
          path={mdiChevronDown}
          size="1.25rem"
          className={cn("shrink-0 text-gray-700 transition-transform duration-200", isOpen && "rotate-180")}
        />
      </button>

      <div
        className="grid transition-[grid-template-rows] duration-200 ease-out"
        style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
      >
        <div className="overflow-hidden min-h-0">
          <div className="pt-0 mt-4 space-y-4">
            <section>
              <h4 className="font-semibold text-label1 text-gray-1000">{t("commonReservationRules")}</h4>
              <ul className="pl-5 mt-1 space-y-1 list-disc text-gray-900 text-body4">
                <li>{t("reservationMaxHoursPerDay")}</li>
              </ul>
            </section>

            <section>
              <h4 className="font-semibold text-label1 text-gray-1000">🥇 {t("silverMembership")}</h4>
              <ul className="pl-5 mt-1 space-y-1 list-disc text-gray-900 text-body4">
                <li>{t("silverNoSameDayReservation")}</li>
                <li>{t("silverFreeHours")}</li>
              </ul>
            </section>

            <section>
              <h4 className="font-semibold text-label1 text-gray-1000">➕ {t("additionalUsageFee")}</h4>
              <ul className="pl-5 mt-1 space-y-1 list-disc text-gray-900 text-body4">
                <li>{t("additionalFeeDescription")}</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingRoomNotice;
